var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlayBuypacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3213_3223)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.999 0.000777372L-0.000244141 30L29.999 59.9992L59.9982 30L29.999 0.000777372Z",
    fill: "url(#paint0_linear_3213_3223)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4948 30.1027L20.529 36.0485L14.9172 41.6375L3.22266 29.8972L14.8002 18.3625L19.4615 23.0409L26.4948 30.1027Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4158 23.8059L13.8639 34.0305C13.7983 34.2988 13.961 34.57 14.2293 34.6385L21.1256 36.3597C21.3939 36.4253 21.6651 36.2626 21.7336 35.9943L24.3168 25.9496C24.4082 25.5928 24.1912 25.2303 23.8344 25.1389L17.0209 23.4377C16.7526 23.372 16.4814 23.5348 16.4129 23.8031L16.4158 23.8059Z",
    fill: "white",
    stroke: "#CDA9F0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3213_3223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 26,
    width: 7,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5133 26.0093L16.115 31.5884L21.2843 32.8839L22.6826 27.3048L17.5133 26.0093Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3213_3223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5975 29.9371L17.6232 29.1921C17.4463 29.1493 17.2693 29.2549 17.2265 29.4319L16.7327 31.4043C16.6898 31.5813 16.7955 31.7583 16.9724 31.8039L19.9467 32.5489C20.1237 32.5917 20.3007 32.4861 20.3464 32.3092L20.8402 30.3368C20.883 30.1598 20.7774 29.9828 20.6004 29.9371H20.5975Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1322 31.2787L21.1513 32.3377C21.2455 32.4348 21.4082 32.3891 21.4424 32.2607L21.8221 30.7507C21.8535 30.6194 21.7307 30.5052 21.6023 30.5451L20.2065 30.999C20.0837 31.039 20.0466 31.1874 20.1351 31.2816L20.1322 31.2787Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1485 28.881C18.8535 29.058 19.5671 28.6298 19.7441 27.9248C19.9211 27.2197 19.4929 26.5061 18.7879 26.3292C18.0828 26.1522 17.3692 26.5803 17.1923 27.2854C17.0153 27.9904 17.4434 28.704 18.1485 28.881Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5491 29.4804C21.2542 29.6574 21.9678 29.2292 22.1447 28.5242C22.3217 27.8192 21.8936 27.1056 21.1885 26.9286C20.4835 26.7516 19.7699 27.1798 19.5929 27.8848C19.4159 28.5899 19.8441 29.3035 20.5491 29.4804Z",
    fill: "#0F0F0F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2751 34.8183H18.454C18.7109 34.8183 18.9192 34.6099 18.9192 34.353V23.7431C18.9192 23.4862 18.7109 23.2778 18.454 23.2778H11.2751C11.0182 23.2778 10.8098 23.4862 10.8098 23.7431V34.353C10.8098 34.6099 11.0182 34.8183 11.2751 34.8183Z",
    fill: "white",
    stroke: "#CDA9F0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 33.0228H13.4757C13.2273 33.0228 13.0218 32.8344 12.999 32.5889L12.7164 29.5119C12.6907 29.2321 12.9105 28.9895 13.1931 28.9895H16.3529C16.6355 28.9895 16.8553 29.2321 16.8296 29.5119L16.547 32.5889C16.5242 32.8344 16.3187 33.0228 16.0703 33.0228Z",
    fill: "#0F0F0F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9697 28.8611H12.4026V29.432H16.9697V28.8611Z",
    fill: "#1D1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0361 28.9867L13.4614 27.6908C13.5613 27.3882 13.8439 27.1827 14.1636 27.1827H15.3682C15.6907 27.1827 15.9762 27.391 16.0732 27.6965L16.4814 28.9781C16.4814 28.9781 14.0751 29.8202 13.0361 28.9838V28.9867Z",
    fill: "#0F0F0F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7716 26.8145C15.2854 26.8145 15.7021 26.3977 15.7021 25.8839C15.7021 25.3701 15.2854 24.9534 14.7716 24.9534C14.2578 24.9534 13.8411 25.3701 13.8411 25.8839C13.8411 26.3977 14.2578 26.8145 14.7716 26.8145Z",
    fill: "#0F0F0F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1685 29.5975L14.8317 29.8658C14.7917 29.8972 14.7375 29.8944 14.7004 29.8658L14.3921 29.6004C14.3664 29.5775 14.355 29.5461 14.3579 29.5119L14.5377 27.548C14.689 27.4624 14.8431 27.4652 14.9972 27.548L15.2056 29.509C15.2056 29.5433 15.1942 29.5775 15.1685 29.6004V29.5975Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49485 36.5224L15.3597 34.6727C15.6281 34.6014 15.7851 34.3273 15.7137 34.059L12.9706 23.883C12.8992 23.6147 12.6252 23.4577 12.3569 23.529L5.492 25.6898C5.22368 25.7612 5.06669 26.0352 5.13805 26.3035L7.88115 36.1713C7.95251 36.4396 8.22654 36.5966 8.49485 36.5252V36.5224Z",
    fill: "white",
    stroke: "#CDA9F0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3213_3223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 26,
    width: 6,
    height: 8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9734 26.5775H7.83545V33.4281H12.9734V26.5775Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3213_3223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7077 30.8248C12.1682 32.2634 10.9236 33.2139 9.52498 33.4166C9.15676 33.4708 8.78568 33.311 8.5716 32.9998C7.82659 31.9237 7.6068 30.5022 8.10347 29.1778C8.6401 27.742 9.88749 26.7915 11.2833 26.5888C11.6515 26.5346 12.0226 26.6944 12.2367 27.0027C12.9817 28.0788 13.2043 29.5032 12.7077 30.8276V30.8248Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51367 29.6575L11.2948 30.3511",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96484 28.45L11.7489 29.1436",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05981 30.8649L10.841 31.5585",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6033 14.6917L36.4711 19.804L35.3407 19.9981L35.0096 21.2598L29.8631 26.3863L23.9173 20.4206L18.3284 14.8088L30.0686 3.1142L41.6033 14.6917Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1504 16.6128C24.7394 10.6556 35.0153 10.353 40.8497 16.5157",
    stroke: "url(#paint1_linear_3213_3223)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7727 20.0267C37.7727 20.0267 36.768 19.5586 35.7689 20.5576C34.7699 21.5567 33.8679 23.9144 33.8679 23.9144L29.963 27.8021L22.1904 19.9981C24.3198 18.2883 27.023 17.2636 29.9659 17.2636C32.9088 17.2636 35.6376 18.2969 37.7727 20.0238V20.0267Z",
    fill: "url(#paint2_linear_3213_3223)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1436 23.9801L32.0979 22.6984L32.1293 20.0067H31.5328L31.567 21.9791C31.2245 22.1161 30.9819 22.1447 30.8648 22.0619C30.6393 21.9077 30.6536 21.2284 30.665 20.5747C30.6707 20.3921 30.6936 20.0067 30.6936 20.0067H30.1569C30.1569 20.0067 30.1798 20.3863 30.1769 20.5633C30.1598 21.4596 30.1455 22.1675 30.5908 22.4729C30.7164 22.5614 30.8677 22.6042 31.0447 22.6042C31.1988 22.6042 31.3758 22.5728 31.5756 22.5043L31.5813 22.7213L31.5528 23.9801H32.1436ZM28.1902 23.3036C28.3244 23.1352 28.4528 22.9839 28.5727 22.844C29.1037 22.2274 29.4861 21.7793 29.4861 21.0058C29.4861 20.1494 28.9524 19.6984 28.4386 19.6984C27.9248 19.6984 27.4053 20.1466 27.4053 21.0058V21.2598H27.9647L27.9248 21.0058C27.9248 20.4606 28.1931 20.2094 28.4386 20.2094C28.5642 20.2094 28.6869 20.2693 28.7783 20.3806C28.8639 20.4834 28.9638 20.6746 28.9638 21.0086C28.9638 21.5938 28.6983 21.9648 28.2074 22.5414C28.0846 22.6813 27.9419 22.8297 27.7878 22.9839C27.6707 23.1038 27.548 23.2265 27.4281 23.3578L27.6736 23.8288L28.7697 23.7574L29.6974 23.8145V23.3036H28.1902Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6413 11.923C34.0789 12.2541 33.5766 12.6251 33.1484 13.0476C33.3254 13.6071 33.4281 14.2236 33.4738 14.8801C33.4852 15.0286 33.3425 15.1456 33.1969 15.1056C32.5575 14.9287 31.9353 14.8231 31.3473 14.8487C31.1275 15.3368 30.7507 15.8506 30.2854 16.373C30.1855 16.4843 30.0028 16.4672 29.9286 16.3359C29.5918 15.7308 29.2207 15.2198 28.8011 14.8459C28.2616 14.9943 27.6479 15.0942 26.9828 15.1599C26.8316 15.1741 26.7088 15.0286 26.7516 14.883C26.8601 14.5005 26.9372 14.1266 26.9771 13.7698C26.9943 13.6328 27.0028 13.5015 27.0057 13.3701C27.0085 13.2617 27.0057 13.1532 27.0057 13.0476C26.4605 12.7422 25.9552 12.3825 25.4786 11.9772C25.3644 11.8801 25.3844 11.6975 25.5128 11.6204C26.0837 11.2779 26.5918 10.9096 27.0057 10.5015C26.7716 9.90773 26.6631 9.29118 26.6603 8.65178C26.6603 8.50335 26.7973 8.39489 26.9372 8.43199C27.588 8.60041 28.2159 8.70031 28.804 8.69746C29.0894 8.12657 29.4491 7.61277 29.8744 7.15036C29.9743 7.04189 30.1484 7.06472 30.2255 7.19032C30.5423 7.71268 30.9077 8.21791 31.3501 8.6946C31.861 8.48908 32.4833 8.38918 33.1798 8.36063C33.3282 8.35492 33.4424 8.49479 33.4024 8.63751C33.2483 9.19127 33.1684 9.81353 33.1512 10.4986C33.6736 10.7583 34.1845 11.1237 34.6784 11.5633C34.7925 11.6632 34.7726 11.843 34.6441 11.9201L34.6413 11.923Z",
    fill: "#0F0F0F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6413 11.923C34.0789 12.2541 33.5766 12.6251 33.1484 13.0476C33.3254 13.6071 33.4281 14.2236 33.4738 14.8801C33.4852 15.0286 33.3425 15.1456 33.1969 15.1056C32.5575 14.9287 31.9353 14.8231 31.3473 14.8487C31.1275 15.3368 30.7507 15.8506 30.2854 16.373C30.1855 16.4843 30.0028 16.4672 29.9286 16.3359C29.5918 15.7308 29.2207 15.2198 28.8011 14.8459C28.2616 14.9943 27.6479 15.0942 26.9828 15.1599C26.8316 15.1741 26.7088 15.0286 26.7516 14.883C26.8601 14.5005 26.9372 14.1266 26.9771 13.7698C26.9943 13.6328 27.0028 13.5015 27.0057 13.3701C27.0085 13.2617 27.0057 13.1532 27.0057 13.0476C26.4605 12.7422 25.9552 12.3825 25.4786 11.9772C25.3644 11.8801 25.3844 11.6975 25.5128 11.6204C26.0837 11.2779 26.5918 10.9096 27.0057 10.5015C26.7716 9.90773 26.6631 9.29118 26.6603 8.65178C26.6603 8.50335 26.7973 8.39489 26.9372 8.43199C27.588 8.60041 28.2159 8.70031 28.804 8.69746C29.0894 8.12657 29.4491 7.61277 29.8744 7.15036C29.9743 7.04189 30.1484 7.06472 30.2255 7.19032C30.5423 7.71268 30.9077 8.21791 31.3501 8.6946C31.861 8.48908 32.4833 8.38918 33.1798 8.36063C33.3282 8.35492 33.4424 8.49479 33.4024 8.63751C33.2483 9.19127 33.1684 9.81353 33.1512 10.4986C33.6736 10.7583 34.1845 11.1237 34.6784 11.5633C34.7925 11.6632 34.7726 11.843 34.6441 11.9201L34.6413 11.923Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 13.5957C31.0106 13.5957 31.8298 12.7764 31.8298 11.766C31.8298 10.7555 31.0106 9.93628 30.0001 9.93628C28.9896 9.93628 28.1704 10.7555 28.1704 11.766C28.1704 12.7764 28.9896 13.5957 30.0001 13.5957Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7716 30.4967L45.1941 42.0314L38.6489 35.4634L33.4995 30.2911L39.4653 24.3454L45.0771 18.7564L56.7716 30.4967Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.238 34.2531C50.3122 32.3692 51.7993 29.1551 50.5662 27.077C49.3303 24.999 45.8393 24.842 42.7679 26.726C39.6966 28.6099 38.2066 31.824 39.4397 33.902C40.6756 35.98 44.1666 36.137 47.238 34.2531Z",
    stroke: "#B98DF6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8183 28.0048C50.6175 28.0048 51.2655 27.3454 51.2655 26.5347C51.2655 25.7241 50.6175 25.0647 49.8183 25.0647C49.019 25.0647 48.3711 25.7241 48.3711 26.5347C48.3711 27.3454 49.019 28.0048 49.8183 28.0048Z",
    fill: "#0F0F0F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4378 31.293C47.0182 31.5442 46.6385 31.8268 46.3217 32.1494C46.453 32.5747 46.5301 33.0428 46.5643 33.5395C46.57 33.6536 46.4673 33.7421 46.3588 33.7107C45.8793 33.5766 45.4169 33.4967 44.9773 33.5138C44.8146 33.8849 44.532 34.2759 44.1837 34.6727C44.1095 34.7583 43.9725 34.744 43.9154 34.6441C43.6614 34.1846 43.3845 33.7964 43.0705 33.5138C42.6652 33.628 42.2085 33.7022 41.709 33.7507C41.5948 33.7621 41.5034 33.6508 41.5377 33.5423C41.6176 33.2512 41.6776 32.9657 41.7061 32.6974C41.7204 32.5947 41.7261 32.4919 41.7261 32.392V32.1494C41.3179 31.9153 40.9383 31.6441 40.5843 31.3359C40.4987 31.2616 40.513 31.1218 40.61 31.0647C41.0353 30.8049 41.4178 30.5252 41.7261 30.2169C41.5491 29.7659 41.4692 29.2949 41.4692 28.8125C41.4692 28.6984 41.5719 28.6156 41.6747 28.647C42.1628 28.7783 42.6309 28.8525 43.0705 28.8496C43.2846 28.4158 43.5529 28.0247 43.8726 27.6736C43.9468 27.5908 44.0781 27.608 44.1324 27.705C44.3693 28.1046 44.6433 28.4871 44.9744 28.8496C45.3569 28.6927 45.8222 28.6156 46.3445 28.5956C46.4559 28.5928 46.5415 28.6984 46.5101 28.804C46.3959 29.2236 46.3331 29.6974 46.3217 30.2198C46.7128 30.4167 47.0953 30.6936 47.4635 31.0304C47.5491 31.1046 47.5348 31.2445 47.4378 31.3016V31.2959V31.293Z",
    fill: "#0F0F0F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9469 32.7716C44.8146 32.7716 45.5168 32.0695 45.5168 31.2017C45.5168 30.334 44.8146 29.6318 43.9469 29.6318C43.0791 29.6318 42.377 30.334 42.377 31.2017C42.377 32.0695 43.0791 32.7716 43.9469 32.7716Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4082 47.6518L35.7288 51.3169C35.7288 51.3169 35.7402 51.3254 35.746 51.3311L29.6917 57.3625C29.6917 57.3625 23.8402 51.1713 23.9315 51.1056L20.4834 47.6432L18.3796 45.5309L23.1694 40.7612L25.1675 38.7688L30.1199 33.8364L36.0657 39.8021L41.6546 45.4139L39.4082 47.6518Z",
    fill: "url(#paint3_linear_3213_3223)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7412 48.2911C25.1903 42.3339 35.2065 42.0314 40.8925 48.1941",
    stroke: "url(#paint4_linear_3213_3223)",
    strokeWidth: 1.97,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.884 47.2207C23.6604 47.2207 24.2913 46.5899 24.2913 45.8135C24.2913 45.0371 23.6604 44.4062 22.884 44.4062C22.1076 44.4062 21.4768 45.0371 21.4768 45.8135C21.4768 46.5899 22.1076 47.2207 22.884 47.2207Z",
    fill: "#452E52",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7364 42.371C26.9628 42.4481 26.3977 43.136 26.4719 43.9096C26.5489 44.6831 27.2369 45.2483 28.0104 45.1741C28.784 45.097 29.3491 44.4091 29.2721 43.6356C29.1979 42.862 28.5071 42.2968 27.7335 42.371H27.7364Z",
    fill: "#452E52",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.179 43.6356C31.179 42.8592 31.8098 42.2283 32.5862 42.2283C33.3626 42.2283 33.9934 42.8592 33.9934 43.6356C33.9934 44.412 33.3626 45.0428 32.5862 45.0428C31.8098 45.0428 31.179 44.412 31.179 43.6356Z",
    fill: "#452E52",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7459 51.3311L35.8543 51.4482L29.7059 57.5081L23.6631 51.314C23.7516 51.2427 23.8401 51.1741 23.9314 51.1085C25.5384 49.9039 27.5337 49.1932 29.6916 49.1932C31.9638 49.1932 34.076 49.9896 35.7287 51.3197C35.7344 51.3254 35.7402 51.3283 35.7459 51.334V51.3311Z",
    fill: "url(#paint5_linear_3213_3223)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.704 46.9895C38.4776 46.9125 39.0427 46.2245 38.9685 45.451C38.8915 44.6774 38.2035 44.1123 37.43 44.1865C36.6564 44.2635 36.0913 44.9515 36.1655 45.725C36.2426 46.4986 36.9305 47.0637 37.704 46.9895Z",
    fill: "#452E52",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9658 45.451C39.0428 46.2245 38.4748 46.9124 37.7012 46.9895C37.5728 47.0009 37.4501 46.9981 37.3273 46.9752C37.3901 46.9838 38.0752 46.4072 37.9895 45.5223C37.9039 44.6375 37.2502 44.2207 37.2502 44.2207C37.3102 44.2036 37.3673 44.195 37.4301 44.1893C38.2036 44.1122 38.8915 44.6803 38.9686 45.4538L38.9658 45.451Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4718 43.9096C26.3948 43.1361 26.9628 42.4482 27.7364 42.3711C27.8648 42.3597 27.9875 42.3625 28.1103 42.3854C28.0475 42.3768 27.3624 42.9534 27.4481 43.8383C27.5337 44.7231 28.1874 45.1399 28.1874 45.1399C28.1274 45.157 28.0703 45.1656 28.0075 45.1713C27.234 45.2483 26.5461 44.6803 26.469 43.9068L26.4718 43.9096Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8429 45.0428L39.0113 39.2112C38.7915 39.4053 38.5032 39.5223 38.1892 39.5223C37.5013 39.5223 36.9447 38.9657 36.9447 38.2778C36.9447 37.9638 37.0617 37.6755 37.2558 37.4557L37.2758 37.4329L22.8581 23.058C23.0522 22.8382 23.1692 22.5528 23.1692 22.2388C23.1692 21.5509 22.6126 20.9943 21.9247 20.9943C21.6107 20.9943 21.3253 21.1113 21.1055 21.3054L14.8657 15.0714",
    stroke: "#0A0A0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1569 15.157L39.0085 21.3054C39.2026 21.5252 39.3196 21.8135 39.3196 22.1275C39.3196 22.8154 38.763 23.372 38.0751 23.372C37.7611 23.372 37.4728 23.255 37.253 23.0609L37.2302 23.0409L22.8553 37.4586C22.6355 37.2645 22.35 37.1475 22.0361 37.1475C21.3481 37.1475 20.7915 37.7041 20.7915 38.392C20.7915 38.706 20.9086 38.9914 21.1027 39.2112L15.2739 45.0457",
    stroke: "#0A0A0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.909 54.5455H28.3813L28.4058 53.3348L28.3635 50.7273H28.8956L28.8667 53.3134L28.909 54.5455Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6364 54.5329L30.7527 54.4807L29.709 54.5455L29.4765 54.1089C29.7375 53.8332 30.0137 53.5868 30.2177 53.3549C30.6869 52.8223 30.9413 52.4797 30.9413 51.9367C30.9413 51.6275 30.8448 51.4521 30.7637 51.3581C30.676 51.2557 30.5619 51.1993 30.4413 51.1993C30.2045 51.1993 29.9502 51.4291 29.9502 51.9367L29.9896 52.1727H29.4546V51.9367C29.4546 51.143 29.9502 50.7273 30.4391 50.7273C30.9281 50.7273 31.4347 51.143 31.4347 51.9367C31.4347 52.651 31.0707 53.0646 30.5663 53.6348C30.4523 53.7643 30.3295 53.9042 30.2001 54.0588H31.6364V54.5309V54.5329Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3213_3223",
    x1: 14.9994,
    y1: 15.0004,
    x2: 44.9986,
    y2: 44.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF80F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFD7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3213_3223",
    x1: 19.1504,
    y1: 14.3154,
    x2: 40.8497,
    y2: 14.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B88CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBA7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3213_3223",
    x1: 33.8176,
    y1: 25.3637,
    x2: 22.363,
    y2: 20.1819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDA9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC92F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3213_3223",
    x1: 30.0171,
    y1: 33.8364,
    x2: 30.0171,
    y2: 57.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#644276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3213_3223",
    x1: 19.7412,
    y1: 45.9938,
    x2: 40.8925,
    y2: 45.9938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5B3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFD6E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3213_3223",
    x1: 23.1818,
    y1: 51,
    x2: 34.909,
    y2: 54.5454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDD4E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3213_3223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlayBuypacks);
export default __webpack_public_path__ + "static/media/how-to-play_buypacks.eef23e8856073e0cd32c583c6aded382.svg";
export { ForwardRef as ReactComponent };